export var TaxTargetValues = [
    'taxed_misc_fee_only',
    'taxed_misc_fee_typica_handling_fee',
    'none',
    'typica_handling_fee_only',
    'all',
];
export var EditableTaxTargetValues = [
    'none',
    'typica_handling_fee_only',
    'all',
];
